import React from "react";
import DepositData from "../../entities/DepositData";

const MobileInnerTable = (props: { depositData: DepositData }) => {
  return (
    <div className="mobile-table">
      <div className="table-wraper">
        <div className="header-table">
          חלוקה לרכיבי הפרשה לפי דיווח המעסיק בש"ח
        </div>
        <div className="content-table">
          <div className="d-flex">
            <div className="w-50">
              <div className="key">תגמולי עובד</div>
              <div className="value">
                {props?.depositData?.depEmployeeSum || "0.00"}
              </div>
            </div>
            <div className="w-50">
              <div className="key">תגמולי מעסיק</div>
              <div className="value">
                {props?.depositData?.depEmployerSum || "0.00"}
              </div>
            </div>
          </div>
          <div className="d-flex">
            <div className="w-50">
              <div className="key">פיצויים</div>
              <div className="value">
                {props?.depositData?.depCompensationSum || "0.00"}
              </div>
            </div>
            <div className="w-50">
              <div className="key">שונות</div>
              <div className="value">
                {props?.depositData?.depDifferentSum || "0.00"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table-wraper">
        <div className="header-table">
          חלוקה לרכיבי הפרשה לפי קליטה בפועל בש"ח
        </div>
        <div className="content-table">
          <div className="d-flex">
            <div className="w-50">
              <div className="key">תגמולי עובד</div>
              <div className="value">
                {props?.depositData?.tranEmployeeSum || "0.00"}
              </div>
            </div>
            <div className="w-50">
              <div className="key">תגמולי מעסיק</div>
              <div className="value">
                {props?.depositData?.tranEmployerSum || "0.00"}
              </div>
            </div>
          </div>
          <div className="d-flex">
            <div className="w-50">
              <div className="key">פיצויים</div>
              <div className="value">
                {props?.depositData?.tranCompensationSum || "0.00"}
              </div>
            </div>
            <div className="w-50">
              <div className="key">שונות</div>
              <div className="value">
                {props?.depositData?.tranDifferentSum || "0.00"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileInnerTable;
